<template>
  <div class="demo_wrap">
    <div class="demo_title_wrap">
      <div class="section-title">预约产品演示</div>
      <div class="section-desc">请完善以下信息，我们的顾问会在1个工作日内与您联系，为您安排产品演示服务</div>
    </div>
    <div class="demo_form hidden-xs-only">
      <div class="demo_form_wrap">
        <Form
          ref="formTop"
          :model="formTop"
          :rules="ruleValidate"
          label-position="top"
          class="demo_form_item1"
        >
          <FormItem label="姓名" class="form_item" prop="input" required>
            <Input
              v-model="formTop.input"
              placeholder="请输入您的姓名"
              size="large"
            ></Input>
          </FormItem>
        </Form>
        <Form
          ref="formTop2"
          :model="formTop2"
          :rules="ruleValidate"
          label-position="top"
          class="demo_form_item1"
        >
          <FormItem label="手机号" class="form_item" prop="phone" required>
            <Input
              v-model="formTop2.phone"
              placeholder="请输入您的手机号"
              size="large"
            ></Input>
          </FormItem>
        </Form>
        <Form
          ref="formTop3"
          :model="formTop3"
          :rules="ruleValidate"
          label-position="top"
          class="demo_form_item1"
        >
          <FormItem label="企业名称" class="form_item" prop="gongsi" required>
            <Input
              v-model="formTop3.gongsi"
              placeholder="请输入您的公司名称"
              size="large"
            ></Input>
          </FormItem>
        </Form>
        <Form
          ref="formTop4"
          :model="formTop3"
          :rules="ruleValidate"
          label-position="top"
          class="demo_form_item1"
        >
          <FormItem label="您的职务" class="form_item">
            <Input
              v-model="formTop3.zhiwu"
              placeholder="请输入您的职务"
              size="large"
            ></Input>
          </FormItem>
        </Form>
        <Form
          ref="formTop5"
          :model="formTop3"
          :rules="ruleValidate"
          label-position="top"
          class="demo_form_item1 form_item_full"
        >
          <FormItem label="备注" class="form_item">
            <Input
              v-model="formTop3.beizhu"
              placeholder="您可以在这儿描述问题和需求,不超过200字"
              type="textarea"
              :rows="5"
              maxlength="200"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div class="form_bottom">
        <div class="checkbox_wrap">
          <el-checkbox v-model="accept" label="1"
            >点击提交视为您已阅读并同意《隐私政策》
          </el-checkbox>
        </div>
        <div class="button_wrap">
          <el-button class="btn" @click="handleReservation">点击预约</el-button>
        </div>
      </div>
    </div>

    <div class="demo_form_mobile hidden-sm-and-up">
      <Form 
        ref="formTopMobile"
        :model="formTopMobile" 
        :rules="ruleValidate"
        label-position="top" 
        class="demo_form_item1"
      >
        <FormItem label="姓名" class="form_item1" prop="input" required>
          <Input
            v-model="formTopMobile.input"
            placeholder="请输入您的姓名"
            size="large"
          ></Input>
        </FormItem>
        <FormItem label="手机号" class="form_item2" prop="phone" required>
          <Input
            v-model="formTopMobile.phone"
            placeholder="请输入您的手机号"
            size="large"
          ></Input>
        </FormItem>
        <FormItem label="您的职务" class="form_item3">
          <Input
            v-model="formTopMobile.zhiwu"
            placeholder="请输入您的职务"
            size="large"
          ></Input>
        </FormItem>
        <FormItem label="备注" class="form_item3">
          <Input
            v-model="formTopMobile.beizhu"
            placeholder="您可以在这儿描述问题和需求,不超过200字"
            type="textarea"
            :rows="4"
            maxlength="200"
          ></Input>
        </FormItem>
      </Form>
      <div class="form_bottom">
        <div class="checkbox_wrap">
          <el-checkbox v-model="accept">点击提交视为您已阅读并同意《隐私政策》</el-checkbox>
        </div>
        <el-button class="btn" @click="handleMobileReservation">点击预约</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/utils/http';

export default {
  data() {
    return {
      formTop: {
        input: '',
        service: '柳叶云',
      },
      formTop2: {
        email: '',
        code: '',
        phone: '',
      },
      formTop3: {
        gongsi: '',
        zhiwu: '',
        beizhu: '',
      },
      formTopMobile: {
        input: '',
        service: '柳叶云',
        email: '',
        code: '',
        phone: '',
        gongsi: '',
        zhiwu: '',
        beizhu: '',
      },
      accept: '1',
      selectData: [
        {
          value: '柳叶云',
          label: '柳叶云',
        },
      ],
      positionOptions: [
        {
          value: '董事长',
          label: '董事长'
        },
        {
          value: '总经理',
          label: '总经理'
        },
        {
          value: '财务主管',
          label: '财务主管'
        },
        {
          value: '仓库主管',
          label: '仓库主管'
        },
        {
          value: '销售主管',
          label: '销售主管'
        }
      ],
      ruleValidate: {
        input: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { type: 'string', min: 2, message: '姓名至少需要2个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        gongsi: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    async handleReservation() {
      if (!this.accept) {
        this.$message.warning('请先阅读并同意隐私政策');
        return;
      }

      try {
        // PC端验证
        await Promise.all([
          this.$refs.formTop.validate(),
          this.$refs.formTop2.validate(),
          this.$refs.formTop3.validate()
        ]);
        
        // 构建提交数据
        const payload = {
          productService: '柳叶云',
          userName: this.formTop.input,
          contactPhone: this.formTop2.phone,
          email: 'default@example.com',
          enterpriseName: this.formTop3.gongsi,
          office: this.formTop3.zhiwu,
          remark: this.formTop3.beizhu
        };

        const res = await http.post(
          '/admin-api/system/official-booking/create',
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
              'tenant-id': 1,
              'Authorization': 'Bearer test1'
            }
          }
        );

        if (res.data && res.data.code === 0) {
          this.$message.success(`预约成功`);
          this.$refs.formTop.resetFields();
          this.$refs.formTop2.resetFields();
          this.$refs.formTop3.resetFields();
          this.accept = false;
        } else {
          this.$message.error(res.data.msg || '预约失败');
        }
      } catch (e) {
        console.error('Error:', e);
        this.$message.error('网络异常，请稍后重试');
      }
    },

    async handleMobileReservation() {
      if (!this.accept) {
        this.$message.warning('请先阅读并同意隐私政策');
        return;
      }

      try {
        // 移动端验证
        await this.$refs.formTopMobile.validate();
        
        // 构建提交数据
        const payload = {
          productService: '柳叶云',
          userName: this.formTopMobile.input,
          contactPhone: this.formTopMobile.phone,
          email: 'mobile@example.com',
          enterpriseName: this.formTopMobile.gongsi,
          office: this.formTopMobile.zhiwu,
          remark: this.formTopMobile.beizhu
        };

        const res = await http.post(
          '/admin-api/system/official-booking/create',
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
              'tenant-id': 1,
              'Authorization': 'Bearer test1'
            }
          }
        );

        if (res.data && res.data.code === 0) {
          this.$message.success(`预约成功`);
          this.$refs.formTopMobile.resetFields();
          this.accept = false;
        } else {
          this.$message.error(res.data.msg || '预约失败');
        }
      } catch (e) {
        console.error('Error:', e);
        this.$message.error('网络异常，请稍后重试');
      }
    }
  },
}
</script>

<style lang="scss"  >
.demo_wrap {
  padding: 40px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;

  @media screen and (max-width: 768px) {
    padding: 30PX 15PX;
  }

  .demo_title_wrap {
    text-align: center;
    margin-bottom: 40px;

    @media screen and (max-width: 768px) {
      margin-bottom: 30PX;
    }
  }

  .demo_form {
    max-width: 800px;
    margin: 0 auto;
    padding: 30px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(10px);

    .demo_form_wrap {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
      margin-bottom: 30px;

      .form_item_full {
        grid-column: 1 / -1;
      }

      .form_row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        grid-column: 1 / -1;
      }
    }

    .form_item {
      .ivu-form-item-label {
        font-size: 16px;
        color: #333;
        font-weight: 500;
      }

      .ivu-input {
        height: 44px;
        border-radius: 8px;
        border: 1px solid #e8e8e8;
        transition: all 0.3s ease;

        &:hover, &:focus {
          border-color: #1890ff;
          box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
        }
      }

      textarea.ivu-input {
        height: auto;
        min-height: 120px;
        resize: vertical;
      }
    }

    .form_bottom {
      text-align: center;
      margin-top: 30px;

      .checkbox_wrap {
        margin-bottom: 20px;
        
        .el-checkbox {
          color: #666;
          
          .el-checkbox__input.is-checked + .el-checkbox__label {
            color: #1890ff;
          }
        }
      }

      .btn {
        width: 200px;
        height: 44px;
        font-size: 16px;
        border-radius: 22px;
        background: linear-gradient(90deg, #1890ff, #52c41a);
        border: none;
        color: #fff;
        font-weight: 500;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 15px rgba(24, 144, 255, 0.2);
        }
      }
    }
  }

  .demo_form_mobile {
    padding: 20PX 15PX;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12PX;
    box-shadow: 0 8PX 24PX rgba(0, 0, 0, 0.05);
    max-width: 600PX;
    margin: 0 auto;
    
    .demo_form_item1 {
      .ivu-form-item {
        margin-bottom: 20PX;
      }

      .ivu-form-item-label {
        font-size: 15PX;
        color: #333;
        padding: 0 0 8PX;
        line-height: 1.4;
        font-weight: 500;
      }

      .ivu-input-wrapper {
        .ivu-input {
          height: 44PX;
          line-height: 44PX;
          border-radius: 8PX;
          font-size: 14PX;
          padding: 0 15PX;
          border: 1PX solid #e8e8e8;

          &::placeholder {
            color: #999;
            font-size: 14PX;
          }

          &:focus {
            border-color: #1890ff;
            box-shadow: 0 0 0 2PX rgba(24, 144, 255, 0.1);
          }
        }

        textarea.ivu-input {
          height: auto;
          min-height: 100PX;
          line-height: 1.6;
          padding: 12PX 15PX;
          resize: none;
        }
      }

      .ivu-form-item-error-tip {
        font-size: 12PX;
        padding-top: 4PX;
      }
    }
    
    .form_bottom {
      margin-top: 30PX;
      
      .checkbox_wrap {
        text-align: left;
        margin-bottom: 20PX;
        padding: 0 10PX;
        
        .el-checkbox {
          font-size: 13PX;
          color: #666;
          
          .el-checkbox__label {
            line-height: 1.4;
            padding-left: 8PX;
          }

          .el-checkbox__input {
            .el-checkbox__inner {
              width: 16PX;
              height: 16PX;
            }
          }
        }
      }
      
      .btn {
        width: 100% !important;
        height: 44PX !important;
        font-size: 16PX !important;
        background: linear-gradient(90deg, #1890ff, #52c41a);
        border: none;
        color: #fff;
        border-radius: 22PX;
        display: flex !important;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        font-weight: 500;
        letter-spacing: 1PX;
        
        &:active {
          opacity: 0.9;
        }
      }
    }
  }
}
</style>